import subtasksFieldUrl from './subtasksField.html';

class SubtasksFieldCtrl {
  subtasksCount = 0;

  constructor(sdk) {
    'ngInject';

    this.TASK_INSTANCE_PENDING_STATUS = sdk('constants').TASK_INSTANCE_PENDING_STATUS;
  }

  $onChanges({ subtasks }) {
    if (subtasks?.currentValue) {
      this.updateSubtaskCount();
    }
  }

  addSubtask() {
    this.subtasks = [...this.subtasks, { title: '', status: this.TASK_INSTANCE_PENDING_STATUS }];
    this.onChange({ subtasks: this.subtasks });
    this.updateSubtaskCount();
  }

  deleteSubtask(subtask) {
    if (this.isTaskInstance) {
      subtask.deleted = true;
    } else {
      this.subtasks = this.subtasks.filter((sub) => sub !== subtask);
    }

    this.onChange({ subtasks: this.subtasks });
    this.updateSubtaskCount();
  }

  updateSubtaskCount() {
    this.subtasksCount = this.subtasks.filter(({ deleted }) => !deleted).length;
  }

  get filteredSubtasks() {
    return this.subtasks?.filter((s) => !s.deleted);
  }

  reordered(item, indexFrom, indexTo) {
    this.subtasks.splice(indexFrom, 1);
    this.subtasks.splice(indexTo, 0, item);

    if (this.isTaskInstance) {
      this.subtasks.forEach((st, index) => {
        st.sortIndex = index;
      });
    }

    this.onChange({ subtasks: this.subtasks });
  }
}

export default {
  templateUrl: subtasksFieldUrl,
  controller: SubtasksFieldCtrl,
  controllerAs: 'ctrl',
  bindings: {
    subtasks: '<',
    onChange: '&',
    isTaskInstance: '<?',
  },
};
